module.exports = __webpack_public_path__ + "static/media/activity_stories.3d6dd6e4.svg";